import { getRootId, getRootType, getParentType } from "@/backend/lib/utils";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { operationTypes } from "@/types/operationTypes";
import { ParameterInputType } from "@/types/parameterTypes";
import { Dropdown } from "react-bootstrap";
import { AddBlockButton } from "../blocks/AddBlockButton";
import { BasicButton } from "../buttons/BasicButton";
import { CustomFieldDropdown } from "../customFIelds/CustomFieldDropdown";
import { Container } from "@/backend/models/containers/container";
import { Block } from "@/backend/models/block";
import { CustomFieldAddButton } from "../customFIelds/CustomFieldAddButton";
import { TableAddButton } from "../parameters/TableAddButton";
import { FieldInputToggle } from "../dropdown/FieldInputToggle";
import { AddGraphButton } from "./AddGraphButton";
import { AddEquipmentButton } from "./AddEquipmentButton";

export function OperationButtonRow(props: { parent: Container | Block, position: number }) {

  const { position, parent } = props;
  const createOperation = useTreeStore((state) => state.createOperation);

  function onClickCreateOperation(operationType: operationTypes, options?: { fieldType?: CUSTOM_FIELD_TYPES, inputType?: ParameterInputType, equipmentId?: string }) {

    const request = {
      parentId: parent.id,
      position,
      isScaffold: parent instanceof Container ? parent.isScaffold: false,
      type: operationType,
      fieldType: options?.fieldType,
      inputType: options?.inputType,
      rootId: getRootId(parent),
      rootType: getRootType(parent),
      parentType: getParentType(parent),
      equipmentId: options?.equipmentId,
    };

    return createOperation(request);
  }

  return (
    <div className="d-flex gap-1 flex-wrap">
        <BasicButton onClick={() => onClickCreateOperation(operationTypes.Commanding)} label={I18n.get('addCommanding')} />
        <CustomFieldDropdown onClick={(fieldType) => void onClickCreateOperation(operationTypes.Field, { fieldType })} label={I18n.get('addField')} />
        <CustomFieldAddButton onClick={(fieldType, inputType) => void onClickCreateOperation(operationTypes.FieldInput, { fieldType, inputType })} label={I18n.get('addFieldInput')} />
        <BasicButton onClick={() => onClickCreateOperation(operationTypes.File)} label={I18n.get('addFile')} />
        <BasicButton onClick={() => onClickCreateOperation(operationTypes.FileInput)} label={I18n.get('addFileInput')} />
        <CustomFieldTextDropdown onClick={(operationType) => void onClickCreateOperation(operationType)} label={I18n.get('addText')} />
        <BasicButton onClick={() => onClickCreateOperation(operationTypes.Code)} label={I18n.get('addCode')} />
        { parent instanceof Container && <TableAddButton onCreate={() => onClickCreateOperation(operationTypes.Table, { fieldType: CUSTOM_FIELD_TYPES.Object, inputType: ParameterInputType.TABLE })} scenario={parent} />}
        {parent instanceof Container && <AddGraphButton parent={parent} position={position} />}
        { parent instanceof Container && <AddEquipmentButton onCreate={(equipmentId) => onClickCreateOperation(operationTypes.Equipment, { equipmentId })} />}
        <AddBlockButton parent={parent} position={position} />
      </div>
  );
}


function CustomFieldTextDropdown(props: {onClick: (operationType: operationTypes) => void, label: string}){
  const { onClick, label } = props;
  return (
    <Dropdown id="dropdown" title="field input">
      <Dropdown.Toggle
        size="sm"
        as={FieldInputToggle({ label })}
      />
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => onClick(operationTypes.Text)}
        >
          {I18n.get('Text')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(operationTypes.Warning)}
        >
          {I18n.get('Warning')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(operationTypes.Danger)}
        >
          {I18n.get('Danger')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(operationTypes.Information)}
        >
          {I18n.get('Information')}
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => onClick(operationTypes.Notes)}
        >
          {I18n.get('notes')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
